import { render, staticRenderFns } from "./SozlesmeAlacakFormWizard.vue?vue&type=template&id=54734ea0"
import script from "./SozlesmeAlacakFormWizard.vue?vue&type=script&lang=ts"
export * from "./SozlesmeAlacakFormWizard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports